// Formateo de fechas/horas para México (zona America/Mexico_City, locale es).
// Reutilizable: homologa cómo se muestran las fechas en la UI de validación.
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import "dayjs/locale/es"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale("es")

const MX_TZ = "America/Mexico_City"

// Intenta parsear valores heterogéneos:
// - ISO 8601 (con o sin zona): "2026-09-27T02:43:51.483892+00:00"
// - Cadenas ya formateadas del ERP ("28 de Septiembre de 2026 - 01:04 AM")
//   se devuelven tal cual (no son parseables de forma fiable).
const _parse = (value) => {
  if (value === null || value === undefined || value === "") return null
  if (value instanceof Date) return dayjs(value)
  const s = String(value)
  // Heurística: si no empieza por dígito, asumimos texto ya formateado.
  if (!/^\d/.test(s)) return null
  const d = dayjs(s)
  return d.isValid() ? d : null
}

// Fecha + hora 24h en zona México: "27/09/2026 20:43".
export const fmtMxDateTime = (value, fallback = "—") => {
  const d = _parse(value)
  if (!d) return value ? String(value) : fallback
  return d.tz(MX_TZ).format("DD/MM/YYYY HH:mm")
}

// Solo fecha: "27/09/2026".
export const fmtMxDate = (value, fallback = "—") => {
  const d = _parse(value)
  if (!d) return value ? String(value) : fallback
  return d.tz(MX_TZ).format("DD/MM/YYYY")
}

// Solo hora 24h: "20:43".
export const fmtMxTime = (value, fallback = "—") => {
  const d = _parse(value)
  if (!d) return value ? String(value) : fallback
  return d.tz(MX_TZ).format("HH:mm")
}

export default fmtMxDateTime
